var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderDecore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 383 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.243 125.002C381.056 184.171 347.214 242.172 297.957 214.927C271.675 200.39 260.435 172.329 233.19 187.585C179.613 217.587 177.627 284.161 130.061 257.183C110.479 246.077 119.385 228.486 119.861 215.258C120.453 198.783 111.162 189.729 94.598 191C73.585 192.611 56.4509 205.252 25.0939 203.486C-4.20005 201.835 -5.84903 164.954 13.322 144.61C24.966 132.253 43.5339 125.64 41.6779 94.5922C40.6009 76.5752 30.9889 47.3362 66.3289 34.2952C108.592 18.7002 140.868 42.6732 169.454 55.3152C198.156 68.0082 230.078 55.4342 242.551 26.7102C244.358 22.5492 245.646 18.1362 247.721 14.1222C254.707 0.607152 268.995 -3.69384 282.514 3.41216C300.654 12.9472 291.253 28.6992 287.264 43.6362C281.433 65.4692 291.847 77.2142 314.082 73.7282C325.965 71.8662 383.784 48.1552 382.243 125.002Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDecore);
export default __webpack_public_path__ + "static/media/headerDecore.6577a4841b62dbb587110a4c5acd4370.svg";
export { ForwardRef as ReactComponent };